var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: [_vm.customClass] },
    [
      _c("div", { staticClass: "full loading-mask border-radius-5" }),
      _vm._v(" "),
      _c("div", { ref: "talkjsContainer", staticClass: "absolute-full" }),
      _vm._v(" "),
      _vm.currentConversationId
        ? [
            _c(
              "div",
              {
                staticClass: "chatbox-back-btn",
                on: { click: _vm.backToMessageList },
              },
              [_c("i", { staticClass: "isif isif-arrow-left" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chatbox-favorite-btn" },
              [
                _c("i-favorite", {
                  attrs: {
                    item: {
                      objectId: _vm.currentCompanyObjectIdInConversation,
                    },
                    category: "user",
                    small: "",
                    animate: "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "chatbox-close-btn",
                on: { click: _vm.closeChatBox },
              },
              [_c("i", { staticClass: "isif isif-close" })]
            ),
          ]
        : [_c("message-list")],
      _vm._v(" "),
      _vm.activeFAQ ? [_c("Chatbot", { attrs: { data: _vm.FAQ } })] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }